var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNavUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1-1h20v20H-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16 9a2 2 0 0 1 2 2v7.25h-2V11h-.292A8.982 8.982 0 0 1 9 14a8.982 8.982 0 0 1-6.708-3H2v7.25H0V11a2 2 0 0 1 2-2h1.255A6.992 6.992 0 0 0 9 12a6.992 6.992 0 0 0 5.745-3H16zm-2.954-1.062a1 1 0 0 1-1.618-1.176 3 3 0 1 0-4.795.082 1 1 0 0 1-1.576 1.23 5 5 0 1 1 7.99-.136z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNavUser);
export default __webpack_public_path__ + "static/media/icon-nav-user.599705c58df0dd818adb000d18587688.svg";
export { ForwardRef as ReactComponent };